import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, link, linkLabel, linkTo }) {
  return (
    <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-12 md:mb-16">
      <div>
        {eyebrow && (
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-4">{eyebrow}</p>
        )}
        <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[0.95]">
          {title}
        </h2>
      </div>
      {link && (
        <a
          data-testid={`section-link-${(linkLabel || "").toLowerCase().replace(/\s+/g, "-")}`}
          href={linkTo}
          className="group font-mono text-xs uppercase tracking-[0.2em] text-gold hover:text-gold-light transition-colors"
        >
          {linkLabel}
          <span className="inline-block ml-2 transition-transform group-hover:translate-x-1">→</span>
        </a>
      )}
    </Reveal>
  );
}
